"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_popper_1 = require("react-popper");
var clsx_1 = __importDefault(require("clsx"));
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var Tooltip = function (props) {
    var title = props.title, content = props.content, actions = props.actions, onActions = props.onActions, children = props.children, trigger = props.trigger, classNameProp = props.className, id = props.id, onClose = props.onClose, onOpen = props.onOpen, openProp = props.open, placementProp = props.placement, invertedBg = props.invertedBg, variant = props._variant, TooltipComp = props._TooltipComp, other = __rest(props, ["title", "content", "actions", "onActions", "children", "trigger", "className", "id", "onClose", "onOpen", "open", "placement", "invertedBg", "_variant", "_TooltipComp"]);
    var _a = React.useState(false), openState = _a[0], setOpenState = _a[1];
    var isControlled = React.useRef(openProp != null).current;
    var nodeRef = React.useRef(null);
    var popperRef = React.useRef(null);
    var isOpen = React.useCallback(function () {
        var isTooltipOpen = false;
        if (variant === 'modal' || title !== '') {
            isTooltipOpen = isControlled ? openProp : openState;
        }
        return isTooltipOpen;
    }, [variant, title, isControlled, openProp, openState]);
    var handleOpen = React.useCallback(function (event) {
        if (!isControlled && !openState) {
            setOpenState(true);
        }
        if (onOpen) {
            onOpen(event);
        }
    }, [isControlled, openState, onOpen]);
    var handleClose = React.useCallback(function (event) {
        if (!isControlled) {
            setOpenState(false);
        }
        if (onClose) {
            onClose(event);
        }
    }, [isControlled, onClose]);
    var handleClick = React.useCallback(function (event) {
        var childrenProps = children.props;
        if (childrenProps.onClick) {
            childrenProps.onClick(event);
        }
        handleOpen(event);
    }, [children.props, handleOpen]);
    var handleDocumentClick = React.useCallback(function (event) {
        if (variant === 'modal') {
            return;
        }
        if (nodeRef.current && nodeRef.current.contains(event.target)) {
            return;
        }
        if (popperRef.current &&
            variant === 'dialog' &&
            popperRef.current.contains(event.target)) {
            return;
        }
        if (isOpen()) {
            handleClose(event);
        }
    }, [isOpen, handleClose, variant]);
    var handleEnter = React.useCallback(function (event) {
        var childrenProps = children.props;
        if (event.type === 'mouseenter' && childrenProps.onMouseEnter) {
            childrenProps.onMouseEnter(event);
        }
        handleOpen(event);
    }, [children.props, handleOpen]);
    var handleLeave = React.useCallback(function (event) {
        var childrenProps = children.props;
        if (event.type === 'blur' && childrenProps.onBlur) {
            childrenProps.onBlur(event);
        }
        else if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
            childrenProps.onMouseLeave(event);
        }
        handleClose(event);
    }, [children.props, handleClose]);
    var handleFocus = React.useCallback(function (event) {
        var childrenProps = children.props;
        if (event.type === 'focus' && childrenProps.onFocus) {
            childrenProps.onFocus(event);
        }
        handleEnter(event);
    }, [children.props, handleEnter]);
    React.useEffect(function () {
        if (trigger === 'click') {
            window.document.body.addEventListener('click', handleDocumentClick);
        }
        return function () {
            window.document.body.removeEventListener('click', handleDocumentClick);
        };
    }, [trigger, handleDocumentClick]);
    var updateArrowStyle = function (arrowProps) {
        if (popperRef.current) {
            var _a = arrowProps.style, left = _a.left, top_1 = _a.top;
            var popperElement = popperRef.current;
            if (left !== '') {
                if (left <= 4) {
                    arrowProps.style.left = '0.25rem';
                }
                else if (popperElement.offsetWidth -
                    popperElement.getElementsByClassName('_ndsTooltip__arrow')[0].offsetWidth -
                    Number(left) <=
                    4) {
                    arrowProps.style.left = "calc(" + arrowProps.style.left / 16 + "rem - 0.25rem)";
                }
            }
            else if (top_1 <= 4) {
                arrowProps.style.top = '0.25rem';
            }
            else if (popperElement.offsetHeight -
                popperElement.getElementsByClassName('_ndsTooltip__arrow')[0].offsetHeight -
                Number(top_1) <=
                4) {
                arrowProps.style.top = "calc(" + arrowProps.style.top / 16 + "rem - 0.25rem)";
            }
        }
    };
    var getChildrenProps = function () {
        var childrenProps = children.props || {};
        var derivedChildrenProps = __assign(__assign(__assign({ 'aria-describedby': isOpen() ? id : null }, childrenProps), other), { className: clsx_1.default(childrenProps.className, {
                _ndsTooltip__reference: isOpen()
            }) });
        if (trigger === 'click') {
            derivedChildrenProps.onClick = handleClick;
        }
        else if (trigger === 'hover') {
            derivedChildrenProps.onMouseEnter = handleEnter;
            derivedChildrenProps.onMouseLeave = handleLeave;
            derivedChildrenProps.onFocus = handleFocus;
            derivedChildrenProps.onBlur = handleLeave;
            derivedChildrenProps.onClick = handleEnter;
        }
        return derivedChildrenProps;
    };
    var RenderTooltipComponent = function (ref, style, placement, arrowProps) {
        return (React.createElement(TooltipComp, { title: title, forwardedRef: reactHelpers_1.createForkRef(ref, popperRef), rootStyle: style, placement: placement, arrowProps: arrowProps, className: classNameProp, content: content, actions: actions, onActions: onActions, onClose: handleClose, invertedBg: invertedBg }));
    };
    var modifiers = {
        offset: {
            offset: "0," + (variant === 'text' ? '12' : '17') + "," + (variant === 'text' ? '12' : '17')
        }
    };
    var PopperElement = (React.createElement(react_popper_1.Popper, { placement: placementProp, modifiers: modifiers }, function (_a) {
        var ref = _a.ref, style = _a.style, placement = _a.placement, arrowProps = _a.arrowProps;
        updateArrowStyle(arrowProps);
        return RenderTooltipComponent(ref, style, placement, arrowProps);
    }));
    return (React.createElement(react_popper_1.Manager, null,
        React.createElement(react_popper_1.Reference, null, function (_a) {
            var ref = _a.ref;
            return React.cloneElement(children, __assign({ ref: reactHelpers_1.createForkRef(children.ref, ref, nodeRef) }, getChildrenProps()));
        }),
        isOpen() && PopperElement));
};
exports.TooltipRootComp = Tooltip;
Tooltip.propTypes = {
    title: function (props, propName, componentName) {
        var variant = props._variant;
        var _a = props, _b = propName, propValue = _a[_b];
        if ((variant === 'dialog' || variant === 'text') && !propValue) {
            return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. `title` property must be provided for for `TooltipDialog` Or `TooltipText`.");
        }
        return null;
    },
    content: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    onClose: prop_types_1.default.func,
    onOpen: prop_types_1.default.func,
    open: prop_types_1.default.bool,
    _variant: prop_types_1.default.oneOf(['text', 'dialog', 'modal']),
    actions: prop_types_1.default.arrayOf(prop_types_1.default.string),
    onActions: prop_types_1.default.arrayOf(prop_types_1.default.func),
    children: prop_types_1.default.element,
    trigger: function (props, propName, componentName) {
        var variant = props._variant;
        var _a = props, _b = propName, propValue = _a[_b];
        if ((variant === 'dialog' || variant === 'modal') && propValue !== 'click') {
            return new Error("Invalid value `" + propValue + "` of prop `" + propName + "` supplied to `" + componentName + "`. trigger property must be `click` for `TooltipDialog` Or `TooltipModal`.");
        }
        if (!['click', 'hover'].includes(propValue)) {
            return new Error("Invalid value `" + propValue + "` of prop `" + propName + "` supplied to `" + componentName + "`. validation failed.");
        }
        return null;
    },
    className: prop_types_1.default.string,
    placement: prop_types_1.default.oneOf([
        'top-start',
        'top',
        'top-end',
        'right-start',
        'right',
        'right-end',
        'bottom-end',
        'bottom',
        'bottom-start',
        'left-end',
        'left',
        'left-start'
    ]),
    invertedBg: prop_types_1.default.bool,
    _TooltipComp: prop_types_1.default.any
};
Tooltip.defaultProps = {
    title: null,
    content: null,
    onClose: undefined,
    onOpen: undefined,
    open: null,
    _variant: 'text',
    actions: [],
    onActions: [],
    children: null,
    trigger: 'hover',
    className: null,
    placement: 'top',
    _TooltipComp: null,
    invertedBg: null
};
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map